"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSalesEnterpriseOwners = exports.getOwnersWithRoles = exports.getCurrentOwnerId = exports.getOwnersIdsAsSelectInputOptions = exports.getFetchOwnersRequestStatus = exports.getOwners = void 0;

var _reselect = require("reselect");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _selectors = require("settings-ui-sdk/Users/selectors");

var _utils = require("settings-ui-sdk/Owners/utils");

var _selectors2 = require("settings-ui-sdk/Auth/selectors");

var _OwnerWithRoles = _interopRequireDefault(require("settings-ui-sdk/Owners/records/OwnerWithRoles"));

var getOwners = function getOwners(state) {
  return state.owners;
};

exports.getOwners = getOwners;
var getFetchOwnersRequestStatus = (0, _getRequestStatus.default)(_actions.OwnersActionTypes.FETCH_OWNERS);
exports.getFetchOwnersRequestStatus = getFetchOwnersRequestStatus;
var getOwnersIdsAsSelectInputOptions = (0, _reselect.createSelector)([getOwners], function (owners) {
  return owners.reduce(function (acc, owner) {
    acc.push({
      text: _I18n.default.text('settingsui.firstNameLastName', {
        firstName: owner.firstName,
        lastName: owner.lastName
      }),
      value: owner.get('ownerId').toString()
    });
    return acc;
  }, []);
});
exports.getOwnersIdsAsSelectInputOptions = getOwnersIdsAsSelectInputOptions;
var getCurrentOwnerId = (0, _reselect.createSelector)([getOwners, _selectors2.getUserId], function (owners, currentUserId) {
  var currentOwner = owners.find(function (owner) {
    return (0, _utils.getUserId)(owner) === currentUserId;
  });
  return currentOwner ? currentOwner.ownerId : null;
});
exports.getCurrentOwnerId = getCurrentOwnerId;
var getOwnersWithRoles = (0, _reselect.createSelector)([getOwners, _selectors.getUsers, _selectors.getRoles], function (owners, users, roles) {
  if (owners.isEmpty() || users.isEmpty() || roles.isEmpty()) {
    return (0, _immutable.Map)();
  }

  var rolesById = roles.reduce(function (rolesMap, role) {
    return rolesMap.set(role.get('id'), role);
  }, (0, _immutable.Map)());
  return owners.reduce(function (ownersMap, owner) {
    var ownerWithRoles = (0, _utils.mapOwnerIsActiveFlag)(new _OwnerWithRoles.default(owner), owner);
    var userId = (0, _utils.getUserId)(owner);

    if (userId && users.has(userId)) {
      var user = users.get(userId);
      var userRoles = user.get('roleIds') ? (0, _immutable.Set)(user.get('roleIds').map(function (roleId) {
        return rolesById.getIn([roleId, 'name']);
      })) : (0, _immutable.Set)(user.get('roleNames'));
      return ownersMap.set(ownerWithRoles.ownerId, ownerWithRoles.merge({
        userId: userId,
        roles: userRoles
      }));
    }

    return ownersMap.set(ownerWithRoles.ownerId, ownerWithRoles.set('userId', userId));
  }, (0, _immutable.Map)());
});
exports.getOwnersWithRoles = getOwnersWithRoles;
var getSalesEnterpriseOwners = (0, _reselect.createSelector)([getOwnersWithRoles], function (ownersWithRoles) {
  return ownersWithRoles.filter(function (owner) {
    return owner.roles && owner.roles.includes('sales-enterprise');
  });
});
exports.getSalesEnterpriseOwners = getSalesEnterpriseOwners;